<script setup lang="ts">
const prefix = 'components.legal.terms';
</script>

<template>
  <div>
    <div class="w-full bg-secondary px-4 pb-5 pt-10 md:px-6 lg:px-8">
      <UiCustomContainer>
        <NuxtLinkLocale
          to="index"
          class="mb-8 inline-flex items-center gap-2 text-gray-600 hover:text-gray-800"
        >
          <SvgoCommonArrowLeft
            filled
            :font-controlled="false"
            class="mt-0.5 h-5 w-5"
          />
          <span class="font-semibold">{{ $t(`${prefix}.backToHome`) }}</span>
        </NuxtLinkLocale>

        <h1 class="mb-10 text-pretty text-center text-3xl font-bold">
          {{ $t('pages.terms.seo.title') }}
        </h1></UiCustomContainer
      >
    </div>

    <div class="flex w-full justify-center px-4 py-10 md:px-6 lg:px-8">
      <div class="max-w-container">
        <div class="mb-8 flex items-center gap-2 text-sm text-gray-600">
          <SvgoLegalClock filled />
          <span>{{ $t(`${prefix}.updatedAt`) }}</span>
        </div>

        <div class="space-y-4 text-secondary-foreground">
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.intro.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.intro.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.intro.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.intro.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.intro.p5`) }}</p>

          <!-- 1 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">1. {{ $t(`${prefix}.s1.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s1.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            {{ $t(`${prefix}.s1.p5Before`) }}
            <NuxtLink
              to="mailto:contact@optionway.com"
              class="text-foreground underline"
              >contact@optionway.com</NuxtLink
            >{{ $t(`${prefix}.s1.p5After`) }}
          </p>

          <!-- 2 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">2. {{ $t(`${prefix}.s2.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s2.p3`) }}</p>

          <!-- 3 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">3. {{ $t(`${prefix}.s3.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s3.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s3.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s3.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s3.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s3.p5`) }}</p>

          <!-- 4 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">4. {{ $t(`${prefix}.s4.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s4.p3`) }}</strong>
          </p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s4.p4`) }}</strong>
          </p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p5`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p6`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p7`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s4.p8`) }}</strong>
          </p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p9`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p10`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p11`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s4.p12Bold`) }}</strong>
            {{ $t(`${prefix}.s4.p12Rest`) }}
          </p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s4.p13`) }}</p>

          <!-- 5 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">5. {{ $t(`${prefix}.s5.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p5`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s5.p6`) }}</p>

          <!-- 6 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">6. {{ $t(`${prefix}.s6.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s6.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s6.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s6.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            {{ $t(`${prefix}.s6.p4Before`) }}<sup>1</sup>
            {{ $t(`${prefix}.s6.p4After`) }}
          </p>
          <p class="text-justify text-base font-normal md:text-lg">
            {{ $t(`${prefix}.s6.p5Before`) }}
            <NuxtLink
              to="mailto:contact@optionway.com"
              class="text-foreground underline"
              >contact@optionway.com</NuxtLink
            >.
          </p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s6.p6`) }}</p>

          <!-- 7 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">7. {{ $t(`${prefix}.s7.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s7.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s7.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s7.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s7.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s7.p5`) }}</strong>
          </p>

          <!-- 8 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">8. {{ $t(`${prefix}.s8.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p5`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p6`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p7`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s8.p8`) }}</p>

          <!-- 9 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">9. {{ $t(`${prefix}.s9.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">
            {{ $t(`${prefix}.s9.p1Start`) }}
            <strong>{{ $t(`${prefix}.s9.p1Bold`) }}</strong>
          </p>
          <p class="text-justify text-base font-normal md:text-lg">
            {{ $t(`${prefix}.s9.p2Start`) }}
            <strong>{{ $t(`${prefix}.s9.p2Bold`) }}</strong>
          </p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s9.p3Bold`) }}</strong>
            {{ $t(`${prefix}.s9.p3Rest`) }}
          </p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s9.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s9.p5`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s9.p6`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s9.p7`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s9.p8`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s9.p9`) }}</p>

          <!-- 10 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">10. {{ $t(`${prefix}.s10.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s10.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s10.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s10.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s10.p4`) }}</p>

          <!-- 11 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">11. {{ $t(`${prefix}.s11.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s11.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s11.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s11.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">
            <strong>{{ $t(`${prefix}.s11.p4`) }}</strong>
          </p>

          <!-- 12 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">12. {{ $t(`${prefix}.s12.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s12.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s12.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s12.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s12.p4`) }}</p>

          <!-- 13 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">13. {{ $t(`${prefix}.s13.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s13.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s13.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s13.p3`) }}</p>

          <!-- 14 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">14. {{ $t(`${prefix}.s14.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s14.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s14.p2`) }}</p>

          <!-- 15 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">15. {{ $t(`${prefix}.s15.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s15.p1`) }}</p>

          <!-- 16 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">16. {{ $t(`${prefix}.s16.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">
            {{ $t(`${prefix}.s16.p1Before`) }}
            <NuxtLink
              to="mailto:contact@optionway.com"
              class="text-foreground underline"
              >contact@optionway.com</NuxtLink
            >{{ $t(`${prefix}.s16.p1After`) }}
          </p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s16.p2`) }}</p>
          <address class="ml-4 mt-2 space-y-1 text-sm not-italic">
            <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s16.mediatorName`) }}</p>
            <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s16.mediatorBp`) }}</p>
            <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s16.mediatorCity`) }}</p>
            <p>
              <NuxtLink
                to="https://www.mtv.travel/"
                target="_blank"
                class="text-primary underline"
              >
                https://www.mtv.travel/
              </NuxtLink>
            </p>
          </address>

          <!-- 17 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">17. {{ $t(`${prefix}.s17.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s17.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s17.p2`) }}</p>

          <!-- 18 -->
          <h2 class="pt-4 text-xl font-medium text-foreground md:text-2xl">18. {{ $t(`${prefix}.s18.title`) }}</h2>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s18.p1`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s18.p2`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s18.p3`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s18.p4`) }}</p>
          <p class="text-justify text-base font-normal md:text-lg">{{ $t(`${prefix}.s18.p5`) }}</p>

          <!-- Footnote -->
          <div class="mt-8 border-t border-gray-200 pt-4 text-sm text-gray-600">
            <p><sup>1</sup> {{ $t(`${prefix}.footnote`) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
